import { useEnvStore } from '@/store/env.store';
import { useTopListStore } from '@/store/top-list/top-list.store';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, onMounted } from 'vue';
import { TOP_LIST_TABLES_MAP } from '@/constants/top-list/top-list-tables.constant';
import { TopListTableType } from '@/models/top-list/top-list-table-type.model';
import { TOP_LIST_COLUMN_LIST } from '@/constants/top-list/top-list-column-list.constant';
import TagListCollapsible from '@/components/tag-list-collapsible/tag-list-collapsible.vue';
import { TopListColumnProperties } from '@/models/top-list/top-list-column-properties.model';
import TokenPagination from '@/components/token-pagination/token-pagination';
import { useTopListFilterStore } from '@/store/top-list/top-list-request-date-parameters.store';
import TopListFilter from '@/layouts/statistics/top-list/top-list-filter/top-list-filter';

export default defineComponent({
  name: 'TopList',
  components: {
    TagListCollapsible,
    TokenPagination,
    TopListFilter,
  },
  setup() {
    const { WL_SLUG } = storeToRefs(useEnvStore());

    const topListStore = useTopListStore();
    const {
      resetPaginationTokens,
      clearTopList,
      getActiveTableList,
    } = topListStore;
    const {
      topList,
      nextPageToken,
      isTopListLoading,
      activeTableName,
    } = storeToRefs(topListStore);

    const { getTopListRequestDateTimeParameter } = storeToRefs(useTopListFilterStore());

    const activeTableType = computed<TopListTableType>(() => {
      return TOP_LIST_TABLES_MAP[activeTableName.value].type;
    });

    const updateActiveTableList = (): void => {
      resetPaginationTokens();
      clearTopList();
      getActiveTableList(WL_SLUG.value, getTopListRequestDateTimeParameter.value);
    };

    const hasNextPage = computed<boolean>(() => Boolean(nextPageToken.value));
    const clickNextPage = (): void => {
      getActiveTableList(WL_SLUG.value, getTopListRequestDateTimeParameter.value);
    };

    const openPlayerProfile = (playerId: string): void => {
      const url = `/player/${playerId}/info?brand=${WL_SLUG.value}`;
      window.open(url, '_blank');
    };

    const isPlayerColumn = (columnProp: string): boolean => {
      return columnProp === TopListColumnProperties.PLAYER_EMAIL;
    };

    onMounted(() => {
      getActiveTableList(WL_SLUG.value, getTopListRequestDateTimeParameter.value);
    });

    return {
      TOP_LIST_TABLES_MAP,
      activeTableType,
      TOP_LIST_COLUMN_LIST,
      clickNextPage,
      hasNextPage,
      isTopListLoading,
      openPlayerProfile,
      isPlayerColumn,
      updateActiveTableList,
      topList,
    };
  },
});
